/**
 * Created by luka on 23.02.2018.
 */

import {LOADING_LOGIN_FAILED, LOGIN, LOGIN_FETCH_DATA_SUCCESS, LOGIN_LOADING, LOGOUT} from "../actions/types";

export function loadingLoginFailed(state = false, action) {
    switch (action.type) {
        case LOADING_LOGIN_FAILED:
            return action.error;
        default:
            return state;
    }
}
export function loginIsLoading(state = false, action) {
    switch (action.type) {
        case LOGIN_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function login(state = {}, action) {
    switch (action.type) {
        case LOGIN_FETCH_DATA_SUCCESS:
            return action.login;
        default:
            return state;
    }
}
const initialState = {
    user: {},
    isLoading:false
};

export function auth(state = initialState, action) {
    switch (action.type) {
        case LOGIN:
            return {
                user: action.user,
                isLoggedIn: action.isLoggedIn
            };
        case LOGOUT:
            return {
                user: {},
                isLoggedIn: action.isLoggedIn
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/login/LoginReducer.js